import { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { emailSelector, userAuthSelector } from 'Store/modules/auth/selectors';
import { taxSelectedSelector } from 'Store/modules/tax/selectors';
import { LandBotProps } from './types';
import * as Styled from './styles';

const LandBot = ({ url, data }: LandBotProps): JSX.Element => {
  const containerRef = useRef(null);
  const { id: userId } = useSelector(userAuthSelector);
  const tax = useSelector(taxSelectedSelector);
  const email = useSelector(emailSelector);

  useEffect(() => {
    let landbot;
    const timer = setTimeout(() => {
      if (window.Landbot) {
        landbot = new window.Landbot.Container({
          configUrl: url,
          container: containerRef.current,
          customData: {
            userId,
            recordId: tax?.recordId,
            email,
            ...data,
          },
        });
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
      landbot?.destroy();
    };
  }, [containerRef]);

  return <Styled.LandBotContainer id="myLandbot" ref={containerRef} />;
};

export default LandBot;
